import { GET_ORGANIZATIONAL_UNIT_INFO, UPDATE_ORGANIZATIONAL_UNIT } from '../../types'
import { CREATE_NEW_UNIT, GET_CATEGORY_EXCLUSIONS } from '../../types/settingsTypes'

const initialState = {
  selectedUnit: {},
  categoryExclusions: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ORGANIZATIONAL_UNIT_INFO: return {
      ...state,
      selectedUnit: { ...action.payload }
    }
    case UPDATE_ORGANIZATIONAL_UNIT: return {
      ...state,
      selectedUnit: { ...action.payload }
    }
    // case UPDATE_UNIT_MONITORING: return {
    //   ...state,
    //   selectedUnit: { ...action.payload }
    // }
    case CREATE_NEW_UNIT: return {
      ...state
    }
    case GET_CATEGORY_EXCLUSIONS: return {
      ...state,
      categoryExclusions: action.payload
    }
    default: return { ...state }
  }
}
